/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/callouts/learnmore/learnmore_styles';



/* ========== ~~~~~~~~~~ LEARN MORE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class LearnMore extends Component {
	constructor(props) {
		super(props);
		this.state = { phase: 'inactive', arrow: <Icon name={`chevron-circle-up`} />, text: 'Learn More' };
	}
	handleClick = (e) => this.setState({ 
		phase: this.state.phase === 'inactive' ? 'active' : 'inactive', 
		arrow: this.state.phase === 'inactive' ? <Icon name={`chevron-circle-down`} /> : <Icon name={`chevron-circle-up`} />, 
		text: this.state.phase === 'inactive' ? `Return` : `Learn More` 
	});
	render() {
		return (
	        <div className={`learnmore ${this.props.classes.learnmore} ${this.state.phase}`}>
	        	<div className={`inner`}>
		        	<div className={`message`}>
		        		{this.props.children}
		        	</div>
		        	<div className={`cta`} onClick={this.handleClick}>
		        		<div className={`button`}>
			        		<div className={`text`}>{this.state.text}</div>
			        		<div className={`arrow`}>{this.state.arrow}</div>
			        	</div>
		        	</div>
		        </div>
	        </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(LearnMore);